import React from 'react';
import './CustomLoading.css';
import { CustomLoadingType } from './types/CustomLoadingType';

/**
 * CustomLoading Component
 * A versatile loading spinner that supports full-page, overlay, and inline modes.
 */
export const CustomLoading: React.FC<CustomLoadingType> = ({
    size = 'medium',
    color,
    label,
    fullPage = false,
    overlay = false,
    className = '',
}) => {
    const containerClasses = [
        'custom-loading-container',
        fullPage ? 'custom-loading--full-page' : '',
        overlay ? 'custom-loading--overlay' : '',
        className
    ].filter(Boolean).join(' ');

    const spinnerStyle = color ? { borderTopColor: color } : {};

    return (
        <div className={containerClasses}>
            <div 
                className={`spinner spinner--${size}`} 
                style={spinnerStyle}
            />
            {label && <p className="custom-loading__label">{label}</p>}
        </div>
    );
};

export default CustomLoading;
